module.exports = __webpack_public_path__ + "static/img/carousel_5_nx3ajx_ar_4_3_w_1534.ecced9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_5_nx3ajx_ar_4_3_w_1534.jpg
// module id = 92VC
// module chunks = 0